import type { FC, SVGProps } from "react";
import { MdOutlinePointOfSale } from "react-icons/md";
import {
  DashboardIcon,
  BusinessIcon,
  ProjectsIcon,
  SearchIcon,
  FolderIcon,
  BusinessIcon as CompanyIcon,
  MapPinIcon,
  UserIcon,
  CheckCircleIcon,
  AddIcon,
  FileTextIcon,
  TrendingUpIcon,
  DownloadIcon,
  ClockIcon,
  DocumentsIcon,
  PartnersIcon,
} from "../../../../shared/cockpit/components/icons/Icon";
import { CalculatorIcon } from "../../../../shared/margincalculator/components/icons/Icon";

export type MenuItem = {
  id: string;
  path: string;
  label: string;
  icon: FC<SVGProps<SVGSVGElement>>;
};

export type MenuSection = {
  title: string | null;
  items: MenuItem[];
};

/**
 * Hauptnavigation (horizontal, oben): Dashboard, CRM, Margenkalkulator, Cockpit, Sales
 */
export const mainNavigation: MenuItem[] = [
  { id: "dashboard", path: "/app", label: "Dashboard", icon: DashboardIcon },
  { id: "crm", path: "/app/crm", label: "CRM", icon: BusinessIcon },
  { id: "calculator", path: "/app/margin-calculator", label: "Margenkalkulator", icon: CalculatorIcon },
  { id: "cockpit", path: "/app/cockpit", label: "Cockpit", icon: ProjectsIcon },
  { id: "Sales", path: "/app/sales", label: "Sales", icon: MdOutlinePointOfSale },
];

/**
 * Sub-Navigation pro Modul (wird unter der Hauptnavigation angezeigt,
 * wenn das jeweilige Modul aktiv ist).
 */
export const moduleNavigation: Record<string, () => MenuSection[]> = {
  crm: () => [
    {
      title: null,
      items: [
        { id: "suche", path: "/app/crm/suche", label: "Suche", icon: SearchIcon },
        { id: "gruppenakten", path: "/app/crm/gruppenakten", label: "Gruppenakten", icon: FolderIcon },
        { id: "gesellschaftsakten", path: "/app/crm/gesellschaftsakten", label: "Gesellschaftsakten", icon: CompanyIcon },
        { id: "standortakten", path: "/app/crm/standortakten", label: "Standortakten", icon: MapPinIcon },
        { id: "kontaktakten", path: "/app/crm/kontaktakten", label: "Kontaktakten", icon: UserIcon },
        { id: "aufgaben", path: "/app/crm/aufgaben", label: "Aufgaben", icon: CheckCircleIcon },
      ],
    },
  ],
  calculator: () => [
    {
      title: null,
      items: [
        { id: "start", path: "/app/margin-calculator", label: "Start & Übersicht", icon: DashboardIcon },
        { id: "eingabe", path: "/app/margin-calculator/calculator", label: "Eingabe", icon: AddIcon },
        { id: "ergebnis", path: "/app/margin-calculator/ergebnis", label: "Ergebnis", icon: FileTextIcon },
        { id: "vergleich", path: "/app/margin-calculator/vergleich", label: "Vergleich", icon: TrendingUpIcon },
        { id: "historie", path: "/app/margin-calculator/historie", label: "Historie", icon: ClockIcon },
        { id: "export", path: "/app/margin-calculator/export", label: "Export", icon: DownloadIcon },
      ],
    },
  ],
  cockpit: () => [
    {
      title: null,
      items: [
        { id: "portfolio", path: "/app/cockpit/portfolio", label: "Portfolio", icon: FolderIcon },
        { id: "projektkopf", path: "/app/cockpit/projektkopf", label: "Projektkopf", icon: DocumentsIcon },
        { id: "strange-gewerke", path: "/app/cockpit/strange-gewerke", label: "Stränge / Gewerke", icon: FolderIcon },
        { id: "arbeitspakete", path: "/app/cockpit/arbeitspakete", label: "Arbeitspakete", icon: PartnersIcon },
      ],
    },
  ],
};

/**
 * Ermittelt das aktive Modul basierend auf dem URL-Pfad.
 */
export function getActiveModule(pathname: string): string | null {
  if (pathname.startsWith("/app/crm")) return "crm";
  if (pathname.startsWith("/app/margin-calculator")) return "calculator";
  if (pathname.startsWith("/app/cockpit")) return "cockpit";
  if (pathname === "/app/sales" || pathname.startsWith("/app/sales/")) return "sales";
  return null;
}
